import React from 'react'
import { StyleSheet } from 'react-native'

import { MotiView } from '@zet/common/components/motiView'
import { Stack, colors } from '@zet/design-system'
import { Skeleton } from 'moti/skeleton'

const AccumulatedPayoutCardLoader = () => {
  return (
    <MotiView
      transition={{
        type: 'timing',
      }}
      style={[styles.container, styles.padded]}
      animate={{ backgroundColor: colors.neutral.white100 }}
    >
      <Stack className="flex-1">
        <Skeleton colorMode={'light'} width={'100%'} height={70} />
      </Stack>
    </MotiView>
  )
}

export default AccumulatedPayoutCardLoader

const styles = StyleSheet.create({
  container: {
    flex: 1,
  },
  padded: {
    padding: 16,
  },
})
